import {ContactVerificationType} from "../Enums/ContactVerificationType";

export default class VerificationTypeToggler {
    public init(): void {
        this.propagateSelectForVerificationValue();
    }

    public initialiseOnCard(cardElement: JQuery): void {
        this.initialiseCard(cardElement);
    }

    private propagateSelectForVerificationValue(): void {
        const cardContainerClass = "contact";

        const cards = jq(`.${cardContainerClass}`);

        cards.each((index, el) => {
            const card = jq(el);
            this.initialiseCard(card);
        });
    }

    private initialiseCard(cardEl: JQuery): void {
        const selectedForVerificationInputClass = "selected-for-verification-selector";
        const verificationButtonClass = "verify-contact-by-verifier-btn";
        const unverifiedBadgeClass = "non-verified-message";
        const toBeVerifiedOnSaveBadgeClass = "to-be-verified-on-save-message";
        const verificationTypeInputClass = "verification-type";

        const verificationTypeInputEl = cardEl.find(`.${verificationTypeInputClass}`) as JQuery<HTMLInputElement>;
        const verificationType = verificationTypeInputEl.val() as string;
        const verificationTypeTyped = ContactVerificationType[verificationType];

        if (verificationTypeTyped === ContactVerificationType.ByRegistrator) {
            cardEl.on("click", `.${verificationButtonClass}`, (event) => {
                event.preventDefault();

                const toBeVerifiedinputEl = cardEl.find(`.${selectedForVerificationInputClass}`) as JQuery<HTMLInputElement>;

                toBeVerifiedinputEl.prop("checked", true);

                cardEl.find(`.${toBeVerifiedOnSaveBadgeClass}`).removeClass("hidden");
                cardEl.find(`.${unverifiedBadgeClass}`).addClass("hidden");

                cardEl.find(`.${verificationButtonClass}`).hide();
            });
        }
    }
}
